/* eslint-disable */
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, postData } from "utils/Gateway";

import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { ecosystemSlug } from "Config/Config";

const AddEditSkillPointModal = ({
  skillPointIndex,
  setSkillPointIndex,
  skillPointData,
  setSkillPointData,
  skillPointListBlock,
  setSkillPointListBlock,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const [allSkills, setAllSkills] = useState([]);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!skillPointData.skill && !String(skillPointData.skillname).trim()) {
      newErrors.skill = t("Skill or Skill Name is required");
      newErrors.skillname = t("Skill or Skill Name is required");
    }

    if (!String(skillPointData.points).trim()) {
      newErrors.points = t("Point is required");
    } else {
      const points = parseInt(skillPointData.points);
      if (isNaN(points) || points < 0 || points > 10) {
        newErrors.points = t("Point must be between 0 and 10");
      }
    }

    if (!String(skillPointData.experienceyear).trim()) {
      newErrors.experienceyear = t("Total Experience is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get all category
  const getAllSkills = async () => {
    try {
      const parentSlug = "skills";

      const response = await getAllCategories(ecosystemSlug, parentSlug);

      setAllSkills(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for add block
  const addSkillPointHandler = () => {
    if (validateForm()) {
      setSkillPointListBlock([...skillPointListBlock, skillPointData]);
      closeModalHandler();
    }
  };

  //function for edit education block
  const editSkillpointBlockHandler = () => {
    if (validateForm()) {
      const updatedSkillPointList = [...skillPointListBlock];
      updatedSkillPointList[skillPointIndex] = skillPointData;
      setSkillPointListBlock(updatedSkillPointList);
      closeModalHandler();
    }
  };

  //close modal handler
  const closeModalHandler = () => {
    setSkillPointData({
      skill: null,
      skillvalue: null,
      skillname: "",
      points: "",
      experienceyear: "",
    });
    setSkillPointIndex(null);
    setErrors({});

    // close the modal of addLabel
    const bootstrapModal = document.querySelector("#addSkillPointModal");
    const modal = bootstrap.Modal.getInstance(bootstrapModal);
    modal.hide();
  };

  useEffect(() => {
    getAllSkills();
  }, []);

  // Custom styles for CreatableSelect
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.skill || errors.skillname ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.skill || errors.skillname ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addSkillPointModal"
      tabIndex="-1"
      aria-labelledby="addEducationModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          {/* ------ modal head section start ----- */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  grade
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-lg text-white mb-0"
                  id="addEducationModalLabel"
                >
                  {t("Save SkillPoint")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your skill point details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalHandler}
            ></button>
          </div>
          {/* ------ modal head section end ----- */}
          {/* ------ modal body section start ----- */}
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ------ skill selection section start ----- */}

                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="selectTags"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Select Skill")}
                  </label>
                  <Select
                    isClearable
                    placeholder={t("Select Skill")}
                    options={allSkills}
                    value={skillPointData.skillvalue}
                    styles={customStyles}
                    onChange={(val) => {
                      if (val) {
                        setSkillPointData((prevData) => ({
                          ...prevData,
                          skillvalue: val,
                          skill: val.value,
                          skillname: val.label,
                        }));
                      } else {
                        setSkillPointData((prevData) => ({
                          ...prevData,
                          skillvalue: null,
                          skill: null,
                          skillname: "",
                        }));
                      }
                      if (errors.skill || errors.skillname) {
                        setErrors((prev) => ({
                          ...prev,
                          skill: "",
                          skillname: "",
                        }));
                      }
                    }}
                    className={errors.skill ? "is-invalid-select" : ""}
                  />
                  {errors.skill && (
                    <div className="invalid-feedback d-block">
                      {errors.skill}
                    </div>
                  )}
                </div>

                {/* ------ skill selection section end ----- */}

                {/* ------ skill name section start ----- */}
                {skillPointData.skillvalue ? null : (
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="university"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Skill Name (* if skill is not in the list)")}
                    </label>
                    <input
                      type="text"
                      className={`form-control fs-sm shadow-none ${
                        errors.skillname
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      placeholder={t("Skill Name")}
                      value={skillPointData.skillname}
                      onChange={(e) => {
                        setSkillPointData((prevData) => ({
                          ...prevData,
                          skillvalue: null,
                          skill: null,
                          skillname: e.target.value,
                        }));
                        if (errors.skillname || errors.skill) {
                          setErrors((prev) => ({
                            ...prev,
                            skillname: "",
                            skill: "",
                          }));
                        }
                      }}
                    />
                    {errors.skillname && (
                      <div className="invalid-feedback">{errors.skillname}</div>
                    )}
                  </div>
                )}
                {/* ------ skill name section end ----- */}

                {/* ------ point section start ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="university"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Point (score between 0 - 10)")}
                  </label>
                  <input
                    type="number"
                    className={`form-control fs-sm shadow-none ${
                      errors.points ? "is-invalid" : "border border-gray-300"
                    }`}
                    placeholder={t("Point")}
                    max="10"
                    value={skillPointData.points}
                    onChange={(e) => {
                      setSkillPointData((prevData) => ({
                        ...prevData,
                        points: e.target.value,
                      }));
                      if (errors.points) {
                        setErrors((prev) => ({ ...prev, points: "" }));
                      }
                    }}
                  />
                  {errors.points && (
                    <div className="invalid-feedback">{errors.points}</div>
                  )}
                </div>
                {/* ------ point section end ----- */}

                {/* ------ point section start ----- */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="university"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Total Experience")}
                  </label>
                  <input
                    type="number"
                    className={`form-control fs-sm shadow-none ${
                      errors.experienceyear
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    placeholder={t("Total Experience")}
                    value={skillPointData.experienceyear}
                    onChange={(e) => {
                      setSkillPointData((prevData) => ({
                        ...prevData,
                        experienceyear: e.target.value,
                      }));
                      if (errors.experienceyear) {
                        setErrors((prev) => ({ ...prev, experienceyear: "" }));
                      }
                    }}
                  />
                  {errors.experienceyear && (
                    <div className="invalid-feedback">
                      {errors.experienceyear}
                    </div>
                  )}
                </div>
                {/* ------ point section end ----- */}
                {/* ------ add/edit button start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={
                      skillPointIndex != null
                        ? editSkillpointBlockHandler
                        : addSkillPointHandler
                    }
                  >
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save SkillPoint")}
                  </button>
                </div>
                {/* ------ add/edit button end ----- */}
              </form>
            </div>
          </div>
          {/* ------ modal body section end ----- */}
        </div>
      </div>
    </div>
  );
};
export default AddEditSkillPointModal;
